import React, { useEffect, useState } from 'react';
import styled from 'astroturf/react';

import { Button } from 'js/design_system/Button';
import trackClick from 'js/utils/trackClick';
import _SSRWrapper from "LoswpBulkDownloadButton-SSRWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/single_work/loswp/LoswpBulkDownloadButton.tsx?styleId=SSRWrapper";


const SSRWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "SSRWrapper",
  styles: _SSRWrapper
});

type Props = {
  workId: number;
  loswpDesign: string;
  workUrl: string;
};

export const LoswpBulkDownloadButton: React.FC<Props> = ({
  workId,
  loswpDesign,
  workUrl,
}) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const handleBulkDownload = async () => {
    trackClick({
      source: 'loswp--bulk-download-button--work-card',
      bucket: loswpDesign,
      entityId: workId,
      extra: { source_work_id: workId },
    });

    const { openLoginModal } = await import('js/login_modal/LoginModalManager');

    const url = workUrl.startsWith('http')
      ? new URL(workUrl)
      : new URL(workUrl, window.location.origin);
    url.searchParams.set('bulkDownload', 'true');
    const redirectUrl = url.toString();

    openLoginModal({
      postLoginRedirectUrl: redirectUrl,
      clickTrackingContext: {
        source: 'loswp--bulk-download-button--work-card',
        bucket: loswpDesign,
        entityId: workId,
        extra: { source_work_id: workId },
      },
      configuredText: {
        buttonsPage: {
          header: 'Download your PDF Package',
          subheader:
            'Including papers that cite this and other related papers.',
        },
        emailEntryPage: {
          subheader: 'Sign up or log in to download your PDF package.',
        },
        emailLoginPage: {
          subheader: 'Log in to download your PDF package.',
        },
        emailRegistrationPage: {
          subheader: 'Sign up to download your PDF package.',
        },
      },
      registrationParams: {
        user_source: 'download',
        redirect_url: redirectUrl,
      },
    });
  };

  if (!isMounted) {
    return (
      <SSRWrapper>
        <Button icon="deployed_code_update" secondary>
          Full PDF Package
        </Button>
      </SSRWrapper>
    );
  }

  return (
    <Button icon="deployed_code_update" secondary onClick={handleBulkDownload}>
      Full PDF Package
    </Button>
  );
};

export default LoswpBulkDownloadButton;
